import { useEffect, useState } from "react";
import { Alert, Spin } from "antd";
import { makeApiRequest } from "../../../lib/api";
import { extractIdFromExtendedId, WAITLIST } from "../../../lib/lib";
import { TypeParams } from "../../../types";
import { useTranslation } from "react-i18next"; // Import useTranslation

interface Form4SuccessProps {
  params: TypeParams;
  placeId: number;
  dateId: number | string;
}

const Form4Success: React.FC<Form4SuccessProps> = ({ params, placeId, dateId }) => {
  const { t } = useTranslation(); // Initialize useTranslation
  const [shortDateId, setShortDateId] = useState<number>();
  const [isWaitlist, setIsWaitlist] = useState(`${shortDateId}` === `${WAITLIST}`);
  const [date, setDate] = useState(null);
  const [place, setPlace] = useState(null);
  const [error, setError] = useState("");

  const onLoadForm = async () => {
    setError("");
    try {
      let action = "";
      let content: any = {};
      action = "REACT_GET_ANPASSUNG_PLACE";
      content = { place_id: placeId };
      const responsePlace: string = (await makeApiRequest(params, action, content)) as any;
      const parsed = JSON.parse(responsePlace);
      if (!parsed || parsed.STATUS !== "OK") {
        setError(t('kontrolltermin.success.errorLoadingPlace'));
        return;
      }
      setPlace(parsed.CONTENT);

      if (dateId !== WAITLIST) {
        action = "REACT_GET_ANPASSUNG_DATE";
        content = { date_id: dateId };
        const response = (await makeApiRequest(params, action, content)) as any;
        const parsed_response = JSON.parse(response);
        if (!parsed || parsed.STATUS !== "OK") {
          setError(t('kontrolltermin.success.errorLoadingDate'));
          return;
        }
        const anpassungDate = parsed_response.CONTENT;
        setDate(anpassungDate);
      }
    } catch (error) {
      console.error(error);
      setError(t('kontrolltermin.success.generalError'));
    }
  };

  useEffect(() => {
    const localShortDateId: number = extractIdFromExtendedId(`${dateId}`);
    setShortDateId(localShortDateId);
    setIsWaitlist(`${localShortDateId}` === `${WAITLIST}`);
    onLoadForm();
  }, [dateId]);

  if (!placeId) {
    return <div>{t('kontrolltermin.success.sessionInterrupted')}</div>;
  }

  if (!place || (!date && !isWaitlist && params.page !== "infotermin_registration")) {
    return (
      <div className={"my-lg"}>
        <Spin />
      </div>
    );
  }

  return (
    <>
      {isWaitlist && (
        <>
          <p className={"my-md"}>
            <strong>{t('kontrolltermin.success.weLookForward')}</strong>
          </p>
          <p>
            {t('kontrolltermin.success.waitlistMessage', { placeName: place["name"] })}
          </p>
        </>
      )}

      {params.page !== "infotermin_registration" && !isWaitlist && date && (
        <>
          <p className={"my-md"}>
            <strong>{t('kontrolltermin.success.weLookForward')}</strong>
          </p>
          <p>
            {t('kontrolltermin.success.appointmentMessage', {
              placeName: place["name"],
              secondName: place["second_name"] ? `- ${place["second_name"]}` : "",
              date: date["local_ws_date"],
              time: date["local_ws_time"]
            })}
          </p>
        </>
      )}
      <div className="my-md">
        <a href={place["txt_url"]} target="_blank" rel="noreferrer">
          {t('kontrolltermin.success.locationInfo', { publicName: place["txt_public_name"] })}
        </a>
      </div>

      {error && <Alert message={error} />}
    </>
  );
};

export default Form4Success;
